import { render, staticRenderFns } from "./DropdownLocalizationText.vue?vue&type=template&id=2cb6ecc0&lang=pug&"
import script from "./DropdownLocalizationText.vue?vue&type=script&lang=js&"
export * from "./DropdownLocalizationText.vue?vue&type=script&lang=js&"
import style0 from "./DropdownLocalizationText.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports